import { useStaticQuery, graphql } from "gatsby"

export const useSectionServiceData = () => {
  const data = useStaticQuery(graphql`
    query serviceQuery {
      contentfulSectionServices {
        title
        filters
        serviceCards {
          filters
          title
          shortDescription {
            shortDescription
          }
          image {
            gatsbyImageData(layout: FULL_WIDTH)
            url
          }
        }
      }
    }
  `)

  return data.contentfulSectionServices
}
